export function createSVGElement(tag: string) {
  const el = document.createElementNS("http://www.w3.org/2000/svg", tag)
  if (!el) throw new Error("Could not create an SVG element")
  return el
}

const DIR_LETTERS = "N NNE NE ENE E ESE SE SSE S SSW SW WSW W WNW NW NNW".split(" ")

export function dirToAngle(dir: string) {
  const index = DIR_LETTERS.indexOf(dir)
  if (index === -1) return undefined

  let angle = (index * 360.0) / DIR_LETTERS.length + 180
  if (angle >= 360) angle -= 360
  return angle
}

export function formatNumber(number: number, precision = 0) {
  if (precision === 0) return number.toFixed()

  return number.toFixed(precision).replace(/\.?0+$/, "")
}

export function parseFloat(str: string | null) {
  if (str === null) return undefined

  const value = window.parseFloat(str)
  return Number.isNaN(value) ? undefined : value
}
